module.exports = __webpack_public_path__ + "img/Listening_to_thinking.7751b6d0.gif";